import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import useDialog from 'hooks/useDialog';

import { getAdCssBackgroundColorProp } from 'lib/ads';
import { sendEvent } from 'lib/gtag';

import LandingImage from './Image';

const WishlistDialog = dynamic(
  () => import('components/Wishlist/WishlistDialog'),
  { ssr: false }
);

const FeaturedImage = ({
  bgcolor = ['#ffffff', '#ffffff'],
  className,
  description = null,
  gaEventCategory = null,
  image,
  mobileImage = null,
  url = null,
  openWishlistOnClick = false,
}) => {
  const { showDialog } = useDialog();

  if (openWishlistOnClick) {
    showDialog(WishlistDialog);
  }

  const onImageClick = () => {
    if (!gaEventCategory) {
      return;
    }

    sendEvent({ action: 'featured_image_click', category: gaEventCategory });
  };

  return (
    <div
      className={twMerge('flex w-full justify-center', className)}
      style={{ background: getAdCssBackgroundColorProp(bgcolor) }}
    >
      <LandingImage
        description={description}
        image={image}
        mobileImage={mobileImage}
        url={url}
        onClick={onImageClick}
      />
    </div>
  );
};

FeaturedImage.propTypes = {
  bgcolor: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  description: PropTypes.string,
  gaEventCategory: PropTypes.string,
  image: PropTypes.string.isRequired,
  mobileImage: PropTypes.string,
  openWishlistOnClick: PropTypes.bool,
  url: PropTypes.string,
};

export default FeaturedImage;
